import React from 'react';
import { View, Text } from 'react-native';
import ShiftedBox from '../../core/ShiftedBox';
import { H1 } from '../../core/H1';
import { useTheme } from '../../core/theme';
import OutlineButton from '../../core/OutlineButton';

interface Props {
  onUploadPress: () => void;
}

const InsuranceDetails = (props: Props) => {
  const { fonts } = useTheme();
  const { onUploadPress } = props;
  return (
    <View>
      <ShiftedBox backgroundColor={'white'} borderColor={'black'}>
        <H1 as={'h2'} style={{ ...fonts.sans.bold, fontSize: 18, paddingBottom: 20 }}>
          Insurance Details
        </H1>
        <Text style={{ ...fonts.sans.reg, fontSize: 16, paddingBottom: 43 }}>
          Upload your insurance details by taking photos of both sides of your insurance card
        </Text>
        <View
          style={{
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'center'
          }}
        >
          <OutlineButton
            colorScheme="blue"
            title={'UPLOAD INSURANCE CARD'}
            onPress={() => {
              onUploadPress();
            }}
          />
        </View>
      </ShiftedBox>
    </View>
  );
};

export default InsuranceDetails;
